import createAction from '@wix/communities-blog-client-common/dist/src/services/create-action';

export const ADD_POST = 'post/ADD';
export const addPost = createAction(ADD_POST);
